import { ConditionStatus } from '../../Conditions.constants';

export const typographyStyles = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

const statusChipStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  padding: '4px 8px',
  borderRadius: ({ shape }) => shape.radius.s,
  whiteSpace: 'nowrap',
  maxWidth: '100%',
  overflow: 'hidden',
};

const statusColorConfig = {
  [ConditionStatus.PENDING]: ['warning', 'light'],
  [ConditionStatus.READY_TO_SIGN_OFF]: ['info', 'main'],
  [ConditionStatus.SIGNED_OFF]: ['success', 'main'],
  [ConditionStatus.REJECTED]: ['error', 'light'],
  [ConditionStatus.DELETED]: ['error', 'main'],
};

const statusToStyleMap = Object.fromEntries(
  Object.entries(statusColorConfig).map(([status, [colorKey, bgVariant]]) => [
    status,
    {
      ...statusChipStyles,
      backgroundColor: ({ palette }) => palette[colorKey][bgVariant],
      color: ({ palette }) => palette[colorKey].contrastText,
    },
  ]),
);

export const getStatusStyles = status =>
  statusToStyleMap[status] ?? statusToStyleMap[ConditionStatus.PENDING];
